import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import NotFound from "@/components/errorComponents/404NotFound.vue";
import ServerError from "@/components/errorComponents/500InternalServerError.vue";
import NetworkErr from "@/components/errorComponents/NetworkError.vue";
import store from "@/store";
import VueCookies from "vue-cookies";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: { name: "dashboard" },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "@/views/MainViews/DashboardView.vue"
          ),
        meta: { requiresAuth: true, preLoading: true },
      },
      {
        path: "my-assets",
        name: "myAssetsAndRequests",
        component: () =>
          import(
            /* webpackChunkName: "myAssetsAndRequests" */ "@/views/MainViews/MyAssetsAndRequestsView.vue"
          ),
        redirect: { name: "myAssets" },
        children: [
          {
            path: "assets",
            name: "myAssets",
            component: () =>
              import(
                /* webpackChunkName: "myAssets" */ "@/views/MainViews/MyAssetsAndRequestsViews/MyAssetsView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "requests",
            name: "myRequests",
            component: () =>
              import(
                /* webpackChunkName: "myRequests" */ "@/views/MainViews/MyAssetsAndRequestsViews/MyRequestsView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
        ],
      },
      {
        path: "management",
        name: "management",
        component: () =>
          import(
            /* webpackChunkName: "management" */ "@/views/MainViews/ManagementView.vue"
          ),
        redirect: { name: "manageAssets" },
        children: [
          {
            path: "assets",
            name: "manageAssets",
            component: () =>
              import(
                /* webpackChunkName: "manageAssets" */ "@/views/MainViews/ManagementsViews/ManageAssetsView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "detail/:id",
            name: "assetDetail",
            component: () =>
              import(
                /* webpackChunkName: "assetDetail" */ "@/views/MainViews/ManagementsViews/AssetDetailView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "requests",
            name: "manageRequest",
            component: () =>
              import(
                /* webpackChunkName: "manageRequests" */ "@/views/MainViews/ManagementsViews/ManageRequestsView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "employees",
            name: "manageEmployees",
            component: () =>
              import(
                /* webpackChunkName: "manageEmployees" */ "@/views/MainViews/ManagementsViews/ManageEmployeesView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
          {
            path: "employers-asset/:personal_id",
            name: "employersAsset",
            component: () =>
              import(
                /* webpackChunkName: "employersAsset" */ "@/views/MainViews/ManagementsViews/Employer/EmployerAssetsView.vue"
              ),
            meta: { requiresAuth: true, preLoading: true },
          },
        ],
      },
      {
        path: "places",
        name: "places",
        component: () =>
          import(
            /* webpackChunkName: "mainPlaces" */ "@/views/MainViews/PlacesView.vue"
          ),
        meta: { requiresAuth: true, preLoading: true },
      },
      {
        path: "place/:id",
        name: "childPlaces",
        component: () =>
          import(
            /* webpackChunkName: "childPlaces" */ "@/views/MainViews/ChildPlacesView.vue"
          ),
        meta: { requiresAuth: true, preLoading: true },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/MainViews/LoginView.vue"),
    meta: { requiresAuth: false, preLoading: false },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: NotFound,
    meta: {
      requiresAuth: false,
      preLoading: false,
    },
  },
  {
    path: "/:pathMatch(.*)*/500",
    name: "500",
    component: ServerError,
    meta: {
      requiresAuth: false,
      preLoading: false,
    },
  },
  {
    path: "/:pathMatch(.*)*/network-err",
    name: "NetworkErr",
    component: NetworkErr,
    meta: {
      requiresAuth: false,
      preLoading: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  window.scrollTo(0, 0);
  let authenticated = store.getters.getIsAuthenticated;
  if (VueCookies.isKey("__ASSETS-REFRESH-TOKEN") && !authenticated) {
    store.commit("setIsAuthenticated");
    authenticated = true;
  }
  if (localStorage.getItem("dark-mode") == "true") {
    store.commit("setDarkMode", true);
  }
  if (!authenticated && to.meta.requiresAuth) {
    return { name: "login" };
  }
  if (to.meta.preLoading) {
    store.commit("setLoading", true);
  }
});

router.afterEach((to) => {
  if (to.meta.preLoading) {
    store.commit("setLoading", false);
  }
});

export default router;
